import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { BreakpointObserver } from "@angular/cdk/layout";

export enum ViewType {
  Small,
  Wide,
}

/** Representiert eine Zahlungsart für die UI */
export class Paymentoption {
  /** Bezeichnung der Zahlungsart.
   *  Beispiele: applepay,paywithgoogle,directEbanking,klarna_paynow,twint,amex,diners,discover,jcb,mc,visa
   */
  public name: string;
  /** Pfad zum Bild der Zahlungsart */
  public image: string;
}

export interface CommunityRaw {
  media_name: string;
  is_active: boolean;
  url: string;
}

export class Community {
  public name: string; //z.B. "Tiktok"
  public isActive: boolean; //z.B. true
  public image: string; //z.B. "hypersoft_social_tiktok.svg"
  public url: string; //z.B. "https://www.tiktok.com/@(+Kundenname)" 

  public static fromRaw(data: CommunityRaw): Community {
    const c = new Community();
    c.name = data.media_name;
    c.isActive = data.is_active;
    c.url = data.url;
    return c;
  }

  public static isRawArray(data: any): data is CommunityRaw[] {
    return Array.isArray(data) && data.every(item =>
      typeof item.media_name === "string" &&
      typeof item.is_active === "boolean" &&
      typeof item.url === "string"
    );
  }
}

@Injectable({
  providedIn: "root"
})
export class MainnavService {

  private _viewType = ViewType.Small;
  public get viewType() {
    return this._viewType;
  }
  private _viewTypeSubject: Subject<ViewType> = new Subject<ViewType>();
  public get observeViewTypeChanges(): Observable<ViewType> {
    return this._viewTypeSubject.asObservable();
  }

  private _navigationEnabled: boolean = true;
  public get navigationEnabled(): boolean {
    return this._navigationEnabled;
  }
  public set navigationEnabled(enabled: boolean) {
    this._navigationEnabled = enabled;
    this._navigationEnabledSubject.next(enabled);
  }
  private _navigationEnabledSubject: Subject<boolean> = new Subject<boolean>();
  public get navigationEnabled$(): Observable<boolean> {
    return this._navigationEnabledSubject.asObservable();
  }

  // Shared footer data
  public communities: Community[] = [];
  public paymentoptions: Paymentoption[] = [];
  public terms: any[] = [];
  public canSelectLanguage: boolean = false;
  public currentLocale: string = "";
  public version: string = "";
  public company_name: string = "";
  public isAccessibilityModeActive: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    const me = this;
    me._viewType = me.breakpointObserver.isMatched("(max-width: 784px)") ? ViewType.Small : ViewType.Wide;
    me.breakpointObserver.observe("(max-width: 784px)").subscribe(result => {
      me._viewType = (result.matches) ? ViewType.Small : ViewType.Wide;
      me._viewTypeSubject.next(me._viewType);
    });
  }
}
